import React from "react";

/**
 * MembershipBadge
 * Shows a member's membership flag (Silver / Gold / Platinum).
 * Renders nothing when `tier` is empty, so admin/manager rows stay clean.
 * All tiers use the site theme green (#009640); the emoji + label show the tier.
 *
 * Props:
 *  - tier: "silver" | "gold" | "platinum" | null | undefined
 *  - size: "sm" (default) | "md"
 *  - withLabel: show the tier text next to the icon (default false)
 */
const TIERS = {
  silver: { label: "Silver", icon: "\uD83E\uDD48" },
  gold: { label: "Gold", icon: "\uD83E\uDD47" },
  platinum: { label: "Platinum", icon: "\uD83D\uDC8E" },
};

const THEME_GREEN = "bg-[#009640] text-white border border-[#009640]";

export default function MembershipBadge({
  tier,
  size = "sm",
  withLabel = false,
  className = "",
}) {
  const meta = TIERS[String(tier || "").toLowerCase().trim()];
  if (!meta) return null;

  const sizeClass =
    size === "md" ? "text-[11px] px-2.5 py-[4px] gap-[5px]" : "text-[9px] px-[8px] py-[3px] gap-1";

  return (
    <span
      title={`Membership: ${meta.label}`}
      className={`inline-flex items-center rounded-full font-700 uppercase tracking-wider leading-none whitespace-nowrap ${THEME_GREEN} ${sizeClass} ${className}`}
    >
      <span aria-hidden="true" className="leading-none" style={{ fontSize: size === "md" ? 12 : 10 }}>
        {meta.icon}
      </span>
      {withLabel && <span>{meta.label}</span>}
    </span>
  );
}
